import { render, staticRenderFns } from "./Clench.vue?vue&type=template&id=ba9ac86c&scoped=true&"
import script from "./Clench.vue?vue&type=script&lang=js&"
export * from "./Clench.vue?vue&type=script&lang=js&"
import style0 from "./Clench.vue?vue&type=style&index=0&id=ba9ac86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ac86c",
  null
  
)

export default component.exports